import { IStorage } from "./Storage";
import { injectable } from "inversify";
import "reflect-metadata";
@injectable()
export default class LocalStorageAdapter implements IStorage {
  delete(key: string): void {
    localStorage.removeItem(key);
  }

  set<T>(key: string, value: T): boolean {
    try {
      const isString = typeof value === "string";

      const result = isString ? value : JSON.stringify(value);

      localStorage.setItem(key, result);

      return true;
    } catch (_e) {
      return false;
    }
  }

  get<T = string>(key: string): T | null {
    const value = localStorage.getItem(key);

    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch (_error) {
      return value as T;
    }
  }
}
